export default __webpack_public_path__ + "static/media/feedback.60162282.png";